import { Nav, NavLink } from "reactstrap";
import { WizardNavProps } from "../../../../../../types/Forms";
import { ShippingFormNavData } from "../../../../../../data/formsAndTable/forms/FormLayout";

const ShippingFormNav: React.FC<WizardNavProps> = ({ activeCallBack, steps }) => {
  return (
    <Nav className="horizontal-options shipping-options" pills>
      {ShippingFormNavData.map((data) => (
        <NavLink key={data.id} className={`b-r-0 ${steps === data.id ? "active" : ""}`} onClick={() => activeCallBack(data.id)}>
          <div className="cart-options">
            <div className="stroke-icon-wizard">
              <i className={`fa fa-${data.icon}`} />
            </div>
            <div>
              <h4>{data.title}</h4>
            </div>
          </div>
        </NavLink>
      ))}
    </Nav>
  );
};
export default ShippingFormNav;
